import { Injectable } from '@angular/core';
import {Observable, Subject, of, firstValueFrom} from 'rxjs';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { MatDialog } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';

import { ExpayService } from 'src/app/_services/expay.service';
import { ExternalPayDialogComponent } from '../dialogs/external-pay-dialog/external-pay-dialog.component';
//import { io } from 'socket.io-client';

import * as _ from 'lodash';
import * as moment from 'moment';
import * as io from 'socket.io-client'
import { sum } from 'lodash';
import {HttpClient, HttpHeaders} from "@angular/common/http";
declare const $: any;

@Injectable({
	providedIn: 'root'
})
export class PaymentsService {

	constructor(
		public dialog: MatDialog,
		private httpClient: HttpClient,
		public appService: AppService,
		public entityService: EntityService,
		public generalUtils: GeneralUtilsService,
		public expayService: ExpayService,
	) {

	}

	// --------------------------------------------------------------------------------------------------------------->
	// PAYMENT UTILS
	// --------------------------------------------------------------------------------------------------------------->

	async processNotCashPayment($storage, resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall) {
		const that = this;

		if (this.appService.regionArgs.enablePaymentFees) {
			try {
				const paymentAmount = await this.entityService.servicePost({
					url: `/online-shopper/orders/${resultOrder._id}/payment-intent`,
					data: { "account": parsedPayment.account, "amount": parsedPayment.amount, "tip": { "amount": parsedPayment.tip?.amount || 0 }, "paymentId": parsedPayment._id, checkId: parsedPayment.checkId }
				});
				parsedPayment.amount = paymentAmount.amount
			} catch (ex) {
				throw ex;
			}
		}
		window['LAST_PAYMENT_AMOUNT'] = parsedPayment.amount;

		const baseURL = document.location.origin + "/assets/expayment_ret.html?r=";
		switch (parsedPayment.paymentType) {
			case "CreditGuard":
			case "creditGuard":
				// Separate one for native payment
				if (parsedPayment.providerInfo) {
					const type = parsedPayment.providerInfo?.applePay ? 'applePay' : 'googlePay';
					const nativePayment = { type };
					this.appService.logTemplate("creditGuardBefore", { nativePayment }, "Credit Guard Before");
					return executeCGPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);
				}
				this.appService.logTemplate("creditGuardBefore", {}, "Credit Guard Before");
				// Regular or wallet payment
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/CreditGuardAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: parsedPayment.amount,
						redirectUrlOnSuccess: `${baseURL}success`,
						redirectUrlOnError: `${baseURL}error`,
						redirectUrlOnCancel: `${baseURL}cancel`,
						walletPaymentMethodId: parsedPayment?.walletPaymentMethodId,
						iframeConfigurations: `
                        {
                            "uiCustomData": {
                                "disableTxnRedirectPopup": true,
                                "paymentMethods": []
                            }
                        }`
					}
				}, true) // With reCaptcha validation
					.then(res => {
						return this.expayService.showCreditGuardDialog(res)
							.then((args: any) => {
								parsedPayment.providerInfo = {
									"providerTransactionId": args["transactionId"]
								}
								// Save CG card in wallet
								if (args.saveToWallet) {
									parsedPayment.addPaymentMethodToWallet = true;
								}
								return executeCGPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);
							});
					});
			case "Stripe":
				this.appService.logTemplate("StripeBefore", {}, "Stripe Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/StripeAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: parsedPayment.amount,
					}
				}, true) // With recaptcha validation
					.then(res => {
						return this.expayService.showStripeDialog(parsedPayment, res).then(args => {
							parsedPayment.providerTransactionId = args["transactionId"];
							parsedPayment.disableValidate = true;
							this.appService.logTemplate("stripeAfter", {}, "Stripe After");
							return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
						});
					});
			case "Meshulam":
				let fullName = $storage?.contact?.name || _.get(parsedPayment, 'customerDetails.name') || _.get(resultOrder, 'orderer.name', 'F L');
				if (fullName.indexOf(" ") == -1) fullName += " *";
				let phone = $storage?.contact?.phone || _.get(parsedPayment, 'customerDetails.phone') || _.get(resultOrder, 'orderer.phone');
				let resultURL = `${document.location.origin}/?site=${resultOrder.organization}&oid=${resultOrder._id}`;

				this.appService.logTemplate('MeshulamBefore', {}, "Meshulam Before");
				return this.entityService.servicePost({
					url: `/online-shopper/finance/MeshulamAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: parsedPayment.amount,
						tipAmount: _.get(parsedPayment, 'tip.amount', undefined),
						redirectUrlOnSuccess: `${resultURL}&tr=success`,
						redirectUrlOnError: `${resultURL}&tr=error`,
						redirectUrlOnCancel: `${resultURL}&tr=cancel`,
						//email: 'notrelevant@tabit.com',
						//phone: phone,
						//fullName: fullName,
						source: 'tabitPay',
						//description: _.get(this.$storage.order, 'printData.variables.ORDER_NO'),
						orderId: resultOrder._id
					}
				}).then(res => {
					return this.expayService.showMeshulamDialog(res).then(args => {
						paymentsAddedOnThisCall.push(parsedPayment);
						return resultOrder;

						/*
						parsedPayment.providerInfo = {
							"processToken": args["processToken"],
							"processId": args["processId"]
						}
						parsedPayment.disableValidate = true;
						this.appService.logTemplate('MeshulamAfter', {}, "Meshulam After");
						return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);
						*/
					});
				});
			case "CardPoint":

				const res = await this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/StripeAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: parsedPayment.amount,
					}
				}, true);

				return this.expayService.showCardPointDialog(parsedPayment, res)
					.then(res => {
						parsedPayment.providerInfo = res;
						return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
					});
			case "HeartLand":
				return this.expayService.showHeartLandDialog(parsedPayment)
					.then(res => {
						parsedPayment.providerInfo = res;
						return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
					});
			case "NabEPX":
				this.appService.logTemplate("NabEPXBefore", {}, "NabEPX Before");
				return this.entityService.servicePost({
					url: `/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
					data: _.assign({}, parsedPayment, {
						source: resultOrder.source || 'online',
						redirectUrl: `${this.appService.appConfig.tabitBridge}/finance/transaction-page`
					})
				}).then(res => {
					return this.expayService.showNabEPXDialog(res).then(args => {
						parsedPayment.providerInfo = args["data"];
						return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
					});
				});
				break;
			case "external":
				this.appService.logTemplate("externalPaydBefore", {}, "External Pay Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
					data: _.assign({}, parsedPayment, {
						source: resultOrder.source || 'online',
						returnUrl: document.location.origin + "/assets/expayment_ret.html"
					})
				}, true)
					.then(res => {
						return this.expayService.showExPayDialog({
							paymentId: res.id,
							providerTransactionToken: res.providerTransactionToken,
							redirectUrl: res.redirectUrl
						}).then(args => {
							parsedPayment.providerTransactionToken = res.providerTransactionToken;
							parsedPayment.disableValidate = true;
							this.appService.logTemplate("externalPaydAfter", {}, "External Pay After");
							return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
						});
					});
			case "AuthorizeNet":
				this.appService.logTemplate("AuthorizeNetBefore", {}, "AuthorizeNet Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: _.round(parsedPayment.amount, 2),
						hostedPaymentIFrameCommunicatorUrl: `${document.location.origin}/assets/authorizenet_ret.html`
					}
				}, true) // With reCaptcha validation
					.then(res => {
						return this.expayService.showAuthorizeNetDialog(parsedPayment, res)
							.then((args: any) => {
								parsedPayment = {
									...parsedPayment,
									providerTransactionId: args["transactionId"],
									disableValidate: true,
									verificationDetails: {
										zipCode: args.billTo?.zip,
										address1: args.billTo?.address,
										city: args.billTo?.city,
										state: args.billTo?.state,
									}
								}
								this.appService.logTemplate("AuthorizeNet", {}, "Authorize Net After");
								return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
							});
					});
			case "Magensa":
				this.appService.logTemplate("magensaPaydBefore", {}, "Magensa Pay Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
					data: _.assign({}, parsedPayment, {
						amount: _.round(parsedPayment.amount, 2),
					})
				}, true).then(res => {
					return this.expayService.showMagensaDialog(parsedPayment, res).then((response:any) => {
						parsedPayment.providerInfo = response;
						this.appService.logTemplate("magensaPaydAfter", {}, "Magensa Pay After");
						return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
					});
				});
				break;
			case "adyen":

				// START Adyen WALLET payment
				if (parsedPayment.walletPayment) {
					this.appService.logTemplate("AdyenWalletBefore", {}, "Adyen Wallet Before");
					return this.entityService.post(
						`/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
						{
							amount: _.round(parsedPayment.amount, 2),
							walletPaymentMethodId: parsedPayment.walletPayment,
						}, { 'ros-organization': this.appService.getOrganization() }).then(res => {
							parsedPayment.paymentProcessId = res.paymentProcessId;
							if (!isNaN(res.surcharge)) parsedPayment.amount += res.surcharge;
							return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
						});
				} else {
				// START adyen normal payment
					this.appService.logTemplate("AdyenBefore", {}, "Adyen Before");
					return this.entityService.post(
						`/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
						{
							amount: _.round(parsedPayment.amount, 2),
							successUrl: `${document.location.origin}/assets/adyen/success.html`,
						}, { 'ros-organization': this.appService.getOrganization() }).then(res => {
						return this.expayService.showAdyenDialog(parsedPayment, res, { releaseOrder: releaseOrder, resultOrder: resultOrder, organization: this.appService.getOrganization() }).then(response => {
							return resultOrder;
							//return this.executeNotCashPayment(resultOrder, response, releaseOrder, paymentsAddedOnThisCall);
						});
					});

				}
			case "kashcash":
				this.appService.logTemplate("KashcashBefore", {}, "Kashcash Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/PrepayAccount/${parsedPayment.account}/setup`,
					data: {
						"amount": parsedPayment.amount,
						"tipAmount": parsedPayment.tip?.amount,
						"paymentId": this.appService.getObjectId(),
						"orderId": resultOrder._id,
						"withIframe": true,
					},
				}, true) // With reCaptcha validation
					.then(res => {
						return this.expayService.showKashcashDialog(parsedPayment, res).then(response => {
							this.appService.logTemplate("KashcashAfter", {}, "Kashcash After");
							return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall)
						});
					});
		}
		return this.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);

		async function executeCGPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall) {
			parsedPayment.disableValidate = true;
			that.appService.logTemplate("creditGuardAfter", {}, "Credit Guard After");

			return that.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall);
		}
	}

	executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall, retryCount?) {
		if (!retryCount) retryCount = 0;
		let that = this;
		var unlock = releaseOrder ? '1' : '0';
		parsedPayment.source = resultOrder.source || 'online';
		parsedPayment.returnUrl = document.location.origin + "/assets/expayment_ret.html";

		const logTip = _.get(parsedPayment, 'tip.amount', 0), logData: any = {
			data: {
				totalPayment: parsedPayment.amount,
				tipAmount: logTip,
				amountBeforeTip: parsedPayment.amount - logTip,
				account: parsedPayment.account,
				paymentType: parsedPayment.paymentType,
				//paymentMode: this.$storage.paymentMode
			}
		}

		if (parsedPayment.providerInfo?.applePay || parsedPayment.providerInfo?.googlePay) {
			// Separate one for native payment
			const type = parsedPayment.providerInfo?.applePay ? 'applePay' : 'googlePay';
			const nativePayment = { type };
			logData.nativePayment = nativePayment;
		}

		// delete parsedPayment data for wallet payment
		if (parsedPayment.walletPaymentMethodId) {
			logData.walletPayment = parsedPayment.walletPayment;

			delete parsedPayment.paymentType;
			delete parsedPayment.walletPayment;
		}

		return new Promise((resolve, reject) => {
			const sURL = `${this.appService.appConfig.tabitBridge}/ros/online-shopper/orders/${resultOrder._id}/payments/?unlock=${unlock}`;
			this.entityService.servicePost({
				url: sURL,
				data: parsedPayment,
				loadingCaption: 'PAYMENT_IN_PROGRESS'
			}).then(async (addedPayment) => {
				if (addedPayment.redirectUrl) {
					var providerTransactionToken = addedPayment.providerTransactionToken;
					if (!providerTransactionToken) {
						throw ({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: that.appService.translate("MESSAGES.EX_PAYMENT_ERROR"),
						})
					} else {
						resolve(that.handleExternalPayment(resultOrder, {
							paymentId: addedPayment.payment._id,
							providerTransactionToken: providerTransactionToken,
							redirectUrl: addedPayment.redirectUrl
						}, paymentsAddedOnThisCall));
					}
				} else {
					this.appService.logTemplate("paymentSuccess", logData, "Payment Success");
					paymentsAddedOnThisCall.push(addedPayment);
					// If we added a wallet payment, get the user wallet again
					if (parsedPayment?.addPaymentMethodToWallet) await that.entityService.getUserWallet();
					resolve(resultOrder);
				}
			}).catch((srvErr) => {
				let err = srvErr.error || {}
				logData.data.error = JSON.stringify(err);

				if (srvErr.type == 'PAYMENT_VALIDATION_ERROR') {
					reject(srvErr);
					that.appService.logTemplate("paymentFail", logData, "Payment Fail");
					return;
				}
				if (err.code) err.code += "";
				if (err.code == '409144' || err.code == '409152') {
					that.verifyClientPayment(parsedPayment, err.code == '409152').then(verificationCode => {
						parsedPayment.verificationCode = verificationCode;
						that.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall).then(response => {
							response["verificationCode"] = verificationCode;
							resolve(response);
						}).catch(err => {
							reject(err);
							that.appService.logTemplate("paymentFail", logData, "Payment Fail");
						});
					}).catch(err => {
						reject(err);
					});
					return;
				} else if (retryCount < 3 && (err.code == '409100' || err.code == '409036')) {
					window.setTimeout(() => {
						that.executeNotCashPayment(resultOrder, parsedPayment, releaseOrder, paymentsAddedOnThisCall, ++retryCount).then(response => {
							resolve(response);
						}).catch(err => {
							reject(err)
							that.appService.logTemplate("paymentFail", logData, "Payment Fail");
						});
					}, 5000);
					return;
				} else {
					let errDesc;
					switch (err.code) {
						case "409100": case "409036": errDesc = "MESSAGES.PAYMENT_LOCKED"; break;
						case "20106": errDesc = "MESSAGES.ORDER_NEWPAYMENT_NEEDED"; break;
						case "409945": errDesc = "MESSAGES.PAYMENT_NOT_SUPPORTED"; break;
						case "409047": errDesc = "MESSAGES.ORDER_REQUIERES_IDCARD"; break;
						case "409098": errDesc = "MESSAGES.SHVA_OFFLINE"; break;
						case "409188": errDesc = "MESSAGES.CARD_VALIDATION_MISMATCH"; break;
						case "409031":
							let balance = _.get(err, 'data.providerResponse.budget');
							if (balance) {
								if (!isNaN(balance)) balance = that.appService.parseCurrency(balance);
								errDesc = that.appService.translate("MESSAGES.PAYMENT_QUOTA_EXCEEDED", { v: balance });
							}
					}

					// Handle recaptcha error
					if (srvErr.status == 403) errDesc = "MESSAGES.SESSION_VALIDATION_FAILED";

					const appError = that.generalUtils.serverErrorToAppError(srvErr) ||
					{
						type: 'PAYMENT_VALIDATION_ERROR',
						wasErrorDesc: errDesc != null,
						message: that.appService.translate(errDesc || "MESSAGES.PAYMENT_ERROR"),
						serverError: srvErr,
						code: err.code || srvErr.status
					};
					this.appService.logTemplate("paymentFail", logData, "Payment Fail");
					reject(appError);
				}
			});
		});
	}

	handleExternalPayment(resultOrder, args, paymentsAddedOnThisCall?) {
		let that = this;
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(ExternalPayDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data: { redirectURL: args.redirectUrl },
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result != undefined) {
					let sURL = `/online-shopper/orders/${resultOrder._id}/authorize`;
					this.entityService.servicePost({
						url: sURL,
						data: {
							"paymentId": args.paymentId,
							"providerTransactionToken": args.providerTransactionToken,
							"params": result
						},
						loadingCaption: 'PAYMENT_IN_PROGRESS'
					}).then(response => {
						resolve(response);
					}).catch(err => {
						console.error(err);
						reject({
							type: 'PAYMENT_AUTHRIZATION_ERROR',
							message: that.appService.translate("MESSAGES.EX_PAYMENT_AUTHRIZATION_ERROR"),
							serverError: err
						});
					});
				}
			});
		});
	}

	//---------------------------------------------------------------------------------------------------------------->


	processPreAuthPayment(resultOrder, parsedPayment, releaseOrder) {
		const baseURL = document.location.origin + "/assets/expayment_ret.html?r=";
		switch (parsedPayment.paymentType) {
			case "CreditGuard":
				this.appService.logTemplate("CreditGuardBefore", {}, "Credit Guard Before");
				return this.entityService.servicePost({
					url: `${this.appService.appConfig.tabitBridge}/ros/online-shopper/finance/CreditGuardAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: parsedPayment.amount,
						redirectUrlOnSuccess: `${baseURL}success`,
						redirectUrlOnError: `${baseURL}error`,
						redirectUrlOnCancel: `${baseURL}cancel`,
						walletPaymentMethodId: parsedPayment?.walletPaymentMethodId,
						iframeConfigurations: `
                        {
                            "uiCustomData": {
                                "disableTxnRedirectPopup": true,
                                "paymentMethods": []
                            }
                        }`
					}
				}, true) // With reCaptcha validation
					.then(res => {
						res.addToWallet = true;
						return this.expayService.showCreditGuardDialog(res).then((args: any) => {
								parsedPayment.isPreAuth = true;
								parsedPayment.providerInfo = {
									"providerTransactionId": args["transactionId"]
								}
								return this.entityService.postPayment(parsedPayment, resultOrder , releaseOrder).then(() => {
									return resultOrder;
								});
							});
					});
			case "adyen":
				this.appService.logTemplate("AdyenBefore", {}, "Adyen Before");
				return this.entityService.servicePost({
					url: `/online-shopper/finance/CreditAccounts/${parsedPayment.account}/setup`,
					data: {
						amount: _.round(parsedPayment.amount, 2),
						successUrl: `${document.location.origin}/assets/adyen/success.html`,
					}
				}).then(res => {
					return this.expayService.showAdyenDialog(parsedPayment, res, { releaseOrder: releaseOrder, resultOrder: resultOrder, organization: resultOrder.organization, isPreAuth: true }).then(response => {
						return resultOrder;
					});
				});
		}
	}

	//---------------------------------------------------------------------------------------------------------------->


	formatError(err, $storage?) {
		if (_.get(err, 'data.data.name') === "ItemInventoryOutOfStock") {
			return this.formatInventoryOutOfStockError(err.data.data.outOfStock, $storage);
		}

		let errDesc = "MESSAGES.SERVER_ERROR";
		// Handle recaptcha error
		if (err.status == 403) errDesc = "MESSAGES.SESSION_VALIDATION_FAILED";

		return {
			type: 'SERVER_ERROR',
			code: err.code,
			message: this.appService.translate(errDesc)
		};
	}

	formatInventoryOutOfStockError(outOfStockItems, _storage) {
		let minStock = _storage.rosConfig.outOfStockWhenUnder;
		let items = outOfStockItems.map(o => {
			let name = (_storage.catalog.items.find(i => i._id === o.item) || {}).name;
			let qty = o.required - Math.max(o.stockCount - minStock, 0);
			return `[ ${qty} x ${name} ]`
		}).join('\n');
		return {
			type: 'OUT_OF_STOCK',
			wasErrorDesc: true,
			message: this.appService.translate('MESSAGES.OUT_OF_STOCK', { items: items })
		};
	}

	//---------------------------------------------------------------------------------------------------------------->

	//---------------------------------------------------------------------------------------------------------------->

	verifyClientPayment(args, isRetry) {
		return this.generalUtils.getSMSverificationCode({
			phone: args.customerDetails.phone,
			walletPayment: args.walletPayment
		}, isRetry, this.appService.getOrganization());
	}


	//---------------------------------------------------------------------------------------------------------------->
	// prepare payments config
	//---------------------------------------------------------------------------------------------------------------->

	prepareConfigPayments($storage, paymentAccounts, source, params: any = {}) {
		let brainTreeAccount, heartlandAccount, stripeAccount, hasMobileWallet;
		let giftCardAccounts = [];
		let gratuityPMS = [];

		$storage.paymentAccounts = _.filter(paymentAccounts, (pa) => {
			if (source == 'tabitPay') {
				if (pa.paymentType == 'cash' || pa.paymentType == "LeumiPay" || !pa.tabitPayActive) return false;
			} else if (pa.paymentType == 'cash' || pa.paymentType == "LeumiPay") return false;


			if (pa.paymentType == "10bis" && !params.enableTenbis) return false;
			if (pa.schedule) {
				let timeSlot = _.find(params.timeslots, { _id: pa.schedule });
				if (timeSlot && !this.generalUtils.isTimeslotsActive(timeSlot)) return false;
			}
			pa.enableGratuity = pa.enableTabitpayTip === true;

			if (pa.providerType == "MagensaPaymentProvider") {
				delete pa.isExternal;
				pa.paymentType = "Magensa";
			} else if (pa.providerType == "NabEpxPaymentProvider") {
				delete pa.isExternal;
				pa.paymentType = "NabEPX";
			} else if (pa.providerType == "AdyenPaymentProvider") {
				delete pa.isExternal;
				hasMobileWallet = true;
				pa.paymentType = "adyen";
			} else if (pa.providerType == "AuthorizeNetPaymentProvider") {
				delete pa.isExternal;
				pa.paymentType = "AuthorizeNet";
			} else if (pa.paymentType == "Braintree" || pa.name == "Braintree") {
				pa.paymentType = "Braintree";
				brainTreeAccount = pa;
			} else if (pa.paymentType == 'giftCard') {
				giftCardAccounts.push(pa);
				return false;
			} else if (pa.paymentType == 'CreditGuard') {
				hasMobileWallet = true;
				// TAB-37880 - Decided to remove in order to prevent old CC window being opened
				// if (!settings.showCreditGuardWindow) {
				// 	pa.paymentType = "creditCard";
				// }
			} else if (pa.paymentType == 'Meshulam') {
				pa.cssClass = 'bit-pay-btn';
			} else if (pa.paymentType == 'HeartLand') {
				heartlandAccount = true;
			} else if (pa.paymentType == 'Stripe') {
				stripeAccount = true;
			} else if (pa.paymentType == 'cash') {
				pa.enableGratuity = false;
			}

			if (pa.enableGratuity) {
				gratuityPMS.push(pa);
			}
			return true;
		});


		if (hasMobileWallet) {
			$storage.hasMobileWallet = true;
			this.expayService.initMobileWalletScripts();
		}

		if (gratuityPMS.length) {
			$storage.hasGratuityPMs = true;
			if (gratuityPMS.length < $storage.paymentAccounts.length) {
				let paText = _.map(gratuityPMS, (pm, index) => {
					let ret = pm["name"];
					if (index === 0) return ret;
					return this.appService.translate('_and') + ret;
				});

				$storage.gratuityPAWarning = this.appService.translate("MESSAGES.GRATUITY_PA_WARNING", { pms: paText.join(" ") });
			}
		} else {
			$storage.enableGratuity = false;
		}

		if (giftCardAccounts[0]) {
			let acc = _.cloneDeep(giftCardAccounts[0]);
			acc.accounts = giftCardAccounts;
			acc.isSingleAccount = giftCardAccounts.length == 1
			if (giftCardAccounts.length > 1) {
				acc.hasMultipleAccounts = true;
				acc.name = this.appService.translate("_GIFTCARD.gift_card");
			}
			$storage.giftCards = acc;
			$storage.paymentAccounts.push(acc);
		}
		if (brainTreeAccount) {
			$storage.customPaymentType = 'brainTree';
			$storage.customPaymentAccount = brainTreeAccount;

			$.when(
				$.getScript('https://js.braintreegateway.com/web/3.63.0/js/client.min.js'),
				$.getScript('https://js.braintreegateway.com/web/3.63.0/js/data-collector.min.js'),
				$.getScript('https://js.braintreegateway.com/web/dropin/1.23.0/js/dropin.min.js'),
			).done(function () {
				return true;
			});
		}

		if (heartlandAccount) {
			$.when(
				$.getScript('/assets/heartland/securesubmit.js')
			).done(function () {
				return true;
			});
		}

		if (stripeAccount) {
			$.when(
				$.getScript('https://js.stripe.com/v3/'),
			).done(function () {
				return true;
			});
		}

		this.createUserWalletPms($storage);

	}

	createUserWalletPms($storage) {
		delete $storage.walletPms;
		let userWallet = _.get(this.appService, 'user.wallet');
		if (userWallet) {
			let userPms = _.get(this.appService, 'user.wallet.payments', []);
			let defPM;
			var walletPms = [];
			_.each(userPms, (pm) => {
				$storage.paymentAccounts.find((spm) => {
					if (this.isPushPaymentToWallet(spm, pm)) {
						let newPM = _.cloneDeep(pm);
						newPM.walletPayment = newPM._id;
						newPM.account = spm._id;
						newPM.requireIdPhoneTrans = spm.requireIdPhoneTrans;
						newPM.merchantNumber = spm.merchantNumber;
						if (pm.paymentType == 'adyen') {
							newPM.caption = `${String(newPM.issuer).charAt(0).toUpperCase() + String(newPM.issuer).slice(1)} ${newPM.displayPan}`;
							newPM.icon = ['amex','diners','discover','jcb','mastercard','visa'].includes(newPM.issuer) ? `cc_${newPM.issuer}` : 'cc';
						}else {
							newPM.caption = this.appService.translate(`PMS.${pm.paymentType}`);
							newPM.icon = 'cc';
						}

						walletPms.push(newPM);
						return true; //select the first match from the account
					}
				});
			});
			if (walletPms.length) {
				$storage.walletPms = walletPms;
				defPM = _.find(walletPms, o => { return o.isDefault });
				if (!defPM) defPM = walletPms[0];
				if (defPM) {
					$storage.wallet = {
						pms: walletPms,
						isSinglePM: walletPms.length == 1,
						ccinfo: defPM
					};
				}
			};
		}
	}

	isPushPaymentToWallet(spm, pm) {
		if (
			// Regular validation
			spm.paymentType === pm.paymentType ||
			// CreditGuard typings..
			spm.paymentType == 'CreditGuard' && pm.paymentType == 'creditGuard' ||
			// Support old wallets
			(['creditGuard', 'CreditGuard'].includes(spm.paymentType) && pm.paymentType == 'creditCard')
		) return true;
		return false;
	}

	//--------------------------------------------------------------------------------------------------->
	//--------------------------------------------------------------------------------------------------->
	//--------------------------------------------------------------------------------------------------->

	async createTabOrder(config, args?) {
		const siteId = this.appService.getOrganization();
		const tpConfig = config.tabitpay;
		const pmAccount = tpConfig.tabPaymentAccount;
		const grandTotal = pmAccount ? 0 : 0;
		let parsedOrder: any = {
			_id: args.orderId || this.appService.getObjectId(),
			organization: siteId,
			deliveryInfo: {
				isTabOrder: true,
				tabName: args.tabName,
				isTabOrderPreAuth: pmAccount != null,
				supportPreAuthAmount: pmAccount?.supportPreAuthAmount,
				fixedPreAuthAmount: pmAccount?.fixedPreAuthAmount,
				tabOrderCreator: this.appService.user?._id,
				userAgent: navigator.userAgent,
				platform: navigator.platform,
			},
			onlineSource: { name: "At Table" },
			orderType: "Seated",
			serviceType: "seated",
			balanceDue: grandTotal,  //changing this creates error
			balance: Math.round(grandTotal * 100),
			orderedOffers: [],
			orderedDiscounts: [],
			orderer: {
				name: args.contact.name,
				phone: args.contact.phone,
			},
			verificationCode: args.verificationCode
		}

		const enableAutoLoginToLoyaltyInTabitOrder = true;
		let loyaltyResponse;
		if (enableAutoLoginToLoyaltyInTabitOrder) {
			loyaltyResponse = await this.postCustomerAutoLogin(siteId);
			if (loyaltyResponse) {
				parsedOrder.member = loyaltyResponse.member;
			}
		}

		let resultOrder;
		try {
			if (args.tableId) {
				resultOrder = await this.entityService.servicePost({ url: `/online-shopper/tables/${args.tableId}/orders`, data: parsedOrder })
			} else {
				let tableNumber = args.tableNumber;
				if (args.tableNum) {
					parsedOrder.table = args.tableNum;
					tableNumber = args.tableNum;
				}
				if (tableNumber) {
					parsedOrder.deliveryInfo.notes = `${this.appService.translate('OAT.table_number')} ${tableNumber}`;
				}
				resultOrder = await this.entityService.servicePost({url: '/online-shopper/orders', data: parsedOrder})
			}
		} catch (err) {
			throw err;
		}

		if (pmAccount) {
			resultOrder.source = "tabitPay";
			if (!resultOrder.organization) resultOrder.organization = siteId;
			let parsedPayment = this.generalUtils.getPreparedPayment({
				paymentMethod: pmAccount.paymentType,
				account: pmAccount._id,
				merchantNumber: pmAccount.merchantNumber,
				amount: args?.amountLimit || tpConfig.preAuthPaymentAccount,
				customerDetails: parsedOrder.orderer,
			});

			try {
				await this.processPreAuthPayment(resultOrder, parsedPayment, null);
			} catch (err) {
				throw err;
			}
		}

		const handoffData: any = {
			status: 'ready',
			/*includedPayments: paymentsAddedOnThisCall.map(function (ap) {
				return ap._id
			})*/
		}
		try {
			await this.entityService.servicePost({
				url: `/online-shopper/orders/${resultOrder._id}/handoff`,
				data: handoffData,
				loadingCaption: 'PAYMENT_IN_PROGRESS'
			});
		} catch (err) {
			throw err;
		}

		return { resultOrder, loyaltyResponse: loyaltyResponse.data };
	}

	async addPaymentAuthorization(config, order, amount) {
		const tpConfig = config.tabitpay;
		const pmAccount = tpConfig.tabPaymentAccount;
		let parsedPayment = this.generalUtils.getPreparedPayment({
			paymentMethod: pmAccount.paymentType,
			account: pmAccount._id,
			merchantNumber: pmAccount.merchantNumber,
			amount: amount || tpConfig.preAuthPaymentAccount,
			customerDetails: order.orderer
		});
		try {
			await this.processPreAuthPayment(order, parsedPayment, null);
		} catch (err) {
			throw err;
		}
	}

	async postCustomerAutoLogin(siteId: string) {
		const appConfig = this.appService.appConfig;
		let headers = {
			headers: new HttpHeaders({
				'Authorization': `Bearer ${localStorage.getItem('loyaltyToken')}`,
				'env': appConfig.loyaltyEnv ,
				'JoinChannelGuid': appConfig.loyaltyJoinChannelGUID,
				'siteId': siteId
			})
		}
		return Promise.all([
			firstValueFrom(this.httpClient.get(`${appConfig.tabitLoyaltyAPI}/pos/get-customer-auto-login`, headers)).catch(err => null),
			this.entityService.get(`/online-shopper/clubs/?loyaltyProvider=5cff99288dc6d4e785abc0bf`, null, { 'ros-organization': siteId }).catch(err => [])
		]).then(res => {
			// @ts-ignore
			const loyaltyData = res[0]?.ResponseData;
			if (!loyaltyData) return null;
			const accountGuid = loyaltyData.configurations?.accountGuid?.toLowerCase();
			const loyaltyClub = res[1].find(o => o.accountGuid?.toLowerCase() == accountGuid);
			if (loyaltyClub) {
				return {
					data: {loyaltyData, loyaltyClub},
					member: {
						loyaltyId: _.get(loyaltyData, 'customer.cardNumber'),
						club: loyaltyClub._id,
						name: _.get(loyaltyData, 'customer.fullName'),
						printMessage: _.get(loyaltyData, 'customer.PrintMessage'),
						points: _.get(loyaltyData, 'balance.points', 0),
						identification: {
							value: _.get(loyaltyData, 'customer.cardNumber'),
							method: "cardNum"
						},
					}
				}
			}
		}).catch(error => {
			return null
		});
	}

}
